export default "__VITE_ASSET__Dlan3bAs__"